import { createFileRoute, redirect } from "@tanstack/react-router";

import { isCorporateFinanceAdmin } from "@/features/corporate-finance/lib/access";

export const Route = createFileRoute(
  "/_protected/corporate-finance/taxonomies/$taxonomyId",
)({
  beforeLoad: ({ context }) => {
    if (!isCorporateFinanceAdmin(context.user)) {
      throw redirect({ to: "/corporate-finance/projects" });
    }
  },
});
